import { Box } from "@mui/material";
import { FindGames } from "./FindGames/FindGames";
import { ChooseSeats } from "./ChooseSeats/ChooseSeats";
import { Checkout } from "./Checkout/Checkout";
import { TabHeader } from "./TabHeader";
import React from "react";
import { purchaseSeatsTabUIDs } from "@/global/config/constants";
import { useAppSystem } from "@/global/hooks/useAppSystem";
import { EventPakcages } from "./EventPackages/EventPackages";
import {
  calcDefaultPurchaseSeatTab,
  normalizePurchaseSeatTab,
} from "./utils.purchaseSeats";
import { SelectPerks } from "./SelectPerks/SelectPerks";

// UID for unique identifier
const tabUIDs = purchaseSeatsTabUIDs;

export function PurchaseSeats() {
  // configs
  const { teamConfig, router } = useAppSystem();
  const { teamSchema, purchaseSeatConfigs } = teamConfig;
  const purchaseSeatTab = router.query.purchaseSeatTab as any;

  React.useEffect(() => {
    const defaultTab = calcDefaultPurchaseSeatTab(teamConfig);

    if (!purchaseSeatTab) {
      router.push({
        query: { ...router.query, teamSchema, purchaseSeatTab: defaultTab },
      });
      return;
    }

    // recover malformed tab values coming from mistyped marketing links
    const { tab, extraQuery } = normalizePurchaseSeatTab(
      purchaseSeatTab,
      defaultTab,
      router.query
    );

    if (tab !== purchaseSeatTab) {
      // replace so the broken url never lands in the history stack
      router.replace({
        query: { ...router.query, ...extraQuery, teamSchema, purchaseSeatTab: tab },
      });
    }
  }, [router]);

  return (
    <Box>
      <Box>
        <TabHeader />
      </Box>
      <Box>
        {purchaseSeatTab == tabUIDs.packages && <EventPakcages />}
        {purchaseSeatTab == tabUIDs.findGames && <FindGames />}
        {purchaseSeatTab == tabUIDs.chooseSeats && <ChooseSeats />}
        {purchaseSeatConfigs.isPerksEnabled &&
          purchaseSeatTab == tabUIDs.selectPerks && <SelectPerks />}
        {purchaseSeatTab == tabUIDs.checkout && <Checkout />}
      </Box>
    </Box>
  );
}
